import React from 'react';
import useBreakpoint from 'use-breakpoint';
import './BlockAcquaintance.scss';
import Square from './Square';
import Sticker from './Sticker';
import BuyButton from './BuyButton';
import { isMobile, MQ } from './Media';

import panda2Img from './img/panda-2-x2.png';
import panda3Img from './img/panda-3-x2.png';
import panda5Img from './img/panda-5-x2.png';
import panda7Img from './img/panda-7-x2.png';
import panda8Img from './img/panda-8-x2.png';
import panda9Img from './img/panda-9-x2.png';
import panda11Img from './img/panda-11-x2.png';

import './BlockAcquaintance.scss';

const BlockAcquaintance: React.FC = () => {
    const { minWidth } = useBreakpoint(MQ, 'sm');

    const mobileFour = () => {
        return (
            <>
            <div className='row g-0'>
                <div className='col'>
                    <Square color="purple"></Square>
                </div>
                <div className='col'>
                    <Square color="orange"></Square>
                </div>
            </div>
            <div className='row g-0'>
                <div className='col'>
                    <Square color="green"></Square>
                </div>
                <div className='col'>
                    <Square color="yellow"></Square>
                </div>
            </div>
            <img className="panda-9" src={panda9Img} alt="" />
            </>
        );
    };

    return (
        <div className="block-acquaintance">
            <div className='row g-0'>
                <div className='col d-none d-md-block'>
                    <Square color="blue">
                        <div className="panda">
                            <img src={panda3Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col d-block d-md-none'>
                    <Square color="blue-light">
                        <div className="panda">
                            <img src={panda2Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col d-none d-md-block'>
                    <Square color="orange">
                        <Sticker rotate={26} />
                    </Square>
                </div>
                <div className='col d-none d-md-block'>
                    <Square color="green">
                        <div className="panda">
                            <img src={panda2Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col d-none d-md-block'>
                    <Square color="yellow">
                        
                    </Square>
                </div>
                <div className='col d-block d-md-none'>
                    <Square color="orange">
                        <div className="panda">
                            <img src={panda8Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col d-none d-md-block'>
                    <Square color="red">
                        <Sticker rotate={-26} />
                    </Square>
                </div>
                <div className='col d-none d-md-block'>
                    <Square color="blue">
                        <div className="panda">
                            <img src={panda7Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col d-block d-md-none'>
                    <Square color="green">
                        <div className="panda">
                            <img src={panda5Img} alt="" />
                        </div>
                    </Square>
                </div>
            </div>
            <div className='row g-0'>
                <div className='col-2 d-none d-md-block'>
                    <Square color="blue-light"></Square>
                    <Square color="green"></Square>
                </div>
                <div className='col bg-white acq-text'>
                    <div className="ar-md-2-1 bg-white">
                        <div className="text-center p-3 p-xl-4 d-md-flex flex-column justify-content-around">
                            <h2 className='m-0'>Знакомься!<br />
                                Это панда Фрайди</h2>
                            <p className='lh-1 my-3 my-md-0'>Твой пушистый друг из телевизора!
                            Телеканал Пятница! — ее дом. Фрайди обожает
                            вкусно поесть и очень любит путешествовать.
                            Вместе с пандой ранний завтрак перед школой 
                            станет веселее, а обыкновенная поездка на дачу 
                            превратится в настоящее приключение.</p>
                            <div className="text-center d-none d-md-block">
                                <BuyButton />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-2 d-none d-md-block'>
                    <Square color="orange">
                        <Sticker />
                    </Square>
                    <Square color="blue-light">
                        <div className="panda">
                            <img src={panda9Img} alt="" />
                        </div>
                    </Square>
                </div>
            </div>
            <div className='row g-0 d-none d-md-flex'>
                <div className='col'>
                    <Square color="orange">
                        <Sticker rotate={-20} />
                    </Square>
                </div>
                <div className='col'>
                    <Square color="blue-light"></Square>
                </div>
                <div className='col'>
                    <Square color="yellow">
                        <div className="panda">
                            <img src={panda8Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col'>
                    <Square color="red">
                        <Sticker rotate={-20} />
                    </Square>
                </div>
                <div className='col'>
                    <Square color="green">
                        <div className="panda">
                            <img src={panda5Img} alt="" />
                        </div>
                    </Square>
                </div>
                <div className='col'>
                    <Square color="yellow"></Square>
                </div>
            </div>
            {!isMobile(minWidth) && <img className="panda-11" src={panda11Img} alt="" />}
            {false && isMobile(minWidth) && mobileFour()}
        </div>
    );
};

export default BlockAcquaintance;